import React from 'react';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation(['retailer']);

  return (
    <div className="m-y-triple text-center">
      <h1 className="no-margin">{t('notFoundError', { ns: 'retailer' })}</h1>
    </div>
  );
};

export default NotFound;
